import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { buildLandingPath } from 'utils/pathBuilder';
import { Button } from 'antd';
import './NotFound.scss';

function NotFound() {
  const navigate = useNavigate();
  const { t } = useTranslation('not_found');
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    const countdownTimer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          navigate(buildLandingPath(), { replace: true });
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(countdownTimer);
  }, [navigate]);

  const handleGoHome = () => {
    navigate(buildLandingPath(), { replace: true });
  };

  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h1 className="not-found-code">404</h1>
        <h2 className="not-found-title">{t('title')}</h2>
        <p className="not-found-description">
          {t('description')}
        </p>

        <Button
          type="primary"
          size="large"
          className="not-found-button"
          onClick={handleGoHome}
        >
          {t('goHome')}
        </Button>

        <div className="not-found-redirect">
          <div className="spinner"></div>
          <span>{t('redirecting', { count: countdown })}</span>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
